module.exports = __webpack_public_path__ + "assets/Spacing.41884da5dfe8e145e3c70076887dc146.svg";